module.exports = __webpack_public_path__ + "assets/img/solar-panels-smal.d37a52d4.jpg";